import { useCallback, useState } from "react";

import type {
  PaginatedResponse,
  UseFilterPaginationProps,
  UseFilterPaginationReturn,
} from "./use-filter-pagination";
import { useFilterPagination } from "./use-filter-pagination";

export interface UseFilterPaginationWithPopupProps<T>
  extends UseFilterPaginationProps<T> {
  initialPopupIndex?: number;
}

export interface UseFilterPaginationWithPopupReturn<T>
  extends UseFilterPaginationReturn<T> {
  isOpenPopup: boolean;
  currentIndex: number;
  handleClosePopup: () => void;
  handleClickOnCard: (uid: string, getUid: (item: T) => string) => void;
}

export const useFilterPaginationWithPopup = <T>({
  initialContent,
  fetchFunction,
  initialFilter = "all",
  initialPopupIndex = 0,
}: UseFilterPaginationWithPopupProps<T>): UseFilterPaginationWithPopupReturn<T> => {
  const [isOpenPopup, setOpenPopup] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(initialPopupIndex);

  const baseHook = useFilterPagination({
    initialContent,
    fetchFunction,
    initialFilter,
  });

  const handleClosePopup = useCallback(() => {
    setOpenPopup(false);
  }, []);

  const handleClickOnCard = useCallback(
    (uid: string, getUid: (item: T) => string) => {
      const index = baseHook.currentContent.data.findIndex(
        (item) => getUid(item) === uid,
      );
      setCurrentIndex(index);
      setOpenPopup(true);
    },
    [baseHook.currentContent],
  );

  return {
    ...baseHook,
    isOpenPopup,
    currentIndex,
    handleClosePopup,
    handleClickOnCard,
  };
};
